import React, { useState } from 'react'
import Footer from './separate/Footer'
import { Container, Row, Col } from 'react-bootstrap'
import {
  Lock,
  Unlock,
  Clock,
  TrendingUp,
  Shield,
  Coins,
  ArrowRight,
  Percent,
  Calendar,
  Zap,
} from 'lucide-react'
import './Earn.css'
import NavbarOne from './separate/NavbarOne'
import { useNavigate } from 'react-router-dom'
import PageTitleDes from '../core/support/PageTitleDes'

const cryptoAssets = [
  {
    symbol: 'BTC',
    name: 'Bitcoin',
    icon: '₿',
    color: 'linear-gradient(135deg, #f59e0b 0%, #ea580c 100%)',
    bgColor: 'rgba(245, 158, 11, 0.1)',
    borderColor: 'rgba(245, 158, 11, 0.3)',
    flexible: { apy: 2.5, minLock: 'None' },
    fixed: [
      { days: 30, apy: 4.2 },
      { days: 90, apy: 6.5 },
      { days: 180, apy: 8.0 },
    ],
  },
  {
    symbol: 'ETH',
    name: 'Ethereum',
    icon: 'Ξ',
    color: 'linear-gradient(135deg, #6366f1 0%, #9333ea 100%)',
    bgColor: 'rgba(99, 102, 241, 0.1)',
    borderColor: 'rgba(99, 102, 241, 0.3)',
    flexible: { apy: 3.0, minLock: 'None' },
    fixed: [
      { days: 30, apy: 5.0 },
      { days: 90, apy: 7.2 },
      { days: 180, apy: 9.5 },
    ],
  },
  {
    symbol: 'SOL',
    name: 'Solana',
    icon: '◎',
    color: 'linear-gradient(135deg, #a855f7 0%, #db2777 100%)',
    bgColor: 'rgba(168, 85, 247, 0.1)',
    borderColor: 'rgba(168, 85, 247, 0.3)',
    flexible: { apy: 4.5, minLock: 'None' },
    fixed: [
      { days: 30, apy: 6.8 },
      { days: 90, apy: 9.0 },
      { days: 180, apy: 12.0 },
    ],
  },
  {
    symbol: 'USDT',
    name: 'Tether USD',
    icon: '₮',
    color: 'linear-gradient(135deg, #10b981 0%, #0d9488 100%)',
    bgColor: 'rgba(16, 185, 129, 0.1)',
    borderColor: 'rgba(16, 185, 129, 0.3)',
    isStable: true,
    flexible: { apy: 5.0, minLock: 'None' },
    fixed: [
      { days: 30, apy: 8.0 },
      { days: 90, apy: 10.5 },
      { days: 180, apy: 14.0 },
    ],
  },
]

const EarnHero = () => {
  const navigate = useNavigate()
  return (
    <section className='earn-hero-section'>
      {/* Rotating rings */}
      <div
        className='position-absolute top-50 start-50 translate-middle'
        style={{ width: '500px', height: '500px', pointerEvents: 'none' }}
      >
        <div
          className='position-absolute w-100 h-100 rounded-circle animate-spin-custom'
          style={{
            border: '2px solid rgba(29, 160, 148, 0.2)',
            animationDuration: '20s',
            zIndex: 1,
          }}
        />
        <div
          className='position-absolute rounded-circle animate-spin-custom'
          style={{
            inset: '2rem',
            border: '1px solid rgba(29, 160, 148, 0.1)',
            animationDuration: '15s',
            animationDirection: 'reverse',
            zIndex: 1,
          }}
        />
        <div
          className='position-absolute border-dashed rounded-circle animate-spin-custom'
          style={{
            inset: '4rem',
            border: '1px dashed rgba(29, 160, 148, 0.2)',
            animationDuration: '25s',
            zIndex: 2,
          }}
        />
      </div>
      <div className='vault-glow' style={{ zIndex: 0 }}>
        <div
          style={{
            position: 'absolute',
            inset: 0,
            borderRadius: '50%',
            background: 'rgba(29,160,148,0.08)',
            filter: 'blur(48px)',
            animationDelay: '0s',
          }}
          className='animate-pulse-custom'
        />
        <div
          style={{
            position: 'absolute',
            inset: '2rem',
            borderRadius: '50%',
            background: 'rgba(29,160,148,0.12)',
            filter: 'blur(36px)',
            animationDelay: '0.5s',
          }}
          className='animate-pulse-custom'
        />
        <div
          style={{
            position: 'absolute',
            inset: '4rem',
            borderRadius: '50%',
            background: 'rgba(29,160,148,0.16)',
            filter: 'blur(28px)',
            animationDelay: '1s',
          }}
          className='animate-pulse-custom'
        />
      </div>

      {/* Floating coins */}
      {[
        {
          icon: '₿',
          color: '#f59e0b',
          size: '64px',
          top: '20%',
          left: '15%',
          delay: '0s',
        },
        {
          icon: 'Ξ',
          color: '#818cf8',
          size: '48px',
          top: '30%',
          right: '20%',
          delay: '1s',
        },
        {
          icon: '◎',
          color: '#c084fc',
          size: '56px',
          bottom: '30%',
          left: '20%',
          delay: '2s',
        },
        {
          icon: '₮',
          color: '#34d399',
          size: '40px',
          bottom: '25%',
          right: '15%',
          delay: '0.5s',
        },
      ].map((coin, i) => (
        <div
          key={i}
          className='floating-coin animate-float-custom'
          style={{
            width: coin.size,
            height: coin.size,
            top: coin.top,
            left: coin.left,
            right: coin.right,
            bottom: coin.bottom,
            animationDelay: coin.delay,
            zIndex: 2,
          }}
        >
          <span
            style={{
              color: coin.color,
              fontSize: '1.5rem',
              fontWeight: 'bold',
            }}
          >
            {coin.icon}
          </span>
        </div>
      ))}
      {[...Array(8)].map((_, i) => {
        const top = `${20 + Math.random() * 60}%`
        const left = `${10 + Math.random() * 80}%`
        const size = `${12 + Math.random() * 8}px`
        const delay = `${i * 0.5}s`
        const value = (2 + Math.random() * 12).toFixed(1)
        return (
          <div
            key={`pct-${i}`}
            className='position-absolute animate-float-custom'
            style={{
              top,
              left,
              animationDelay: delay,
              color: 'rgba(29,160,148,0.3)',
              fontWeight: 700,
              fontSize: size,
            }}
          >
            +{value}%
          </div>
        )
      })}

      <Container className='position-relative' style={{ zIndex: 3 }}>
        <div className='text-center mx-auto' style={{ maxWidth: '800px' }}>
          {/* Central vault icon */}
          <div
            className='position-relative mx-auto mb-4 vault-icon-wrapper'
            style={{ width: '128px', height: '128px' }}
          >
            <div
              className='position-absolute w-100 h-100 rounded-circle d-flex align-items-center justify-content-center'
              style={{
                background:
                  'radial-gradient(circle, rgba(29,160,148,0.2) 0%, rgba(29,160,148,0.05) 100%)',
                border: '2px solid rgba(29,160,148,0.3)',
              }}
            >
              <div
                className='rounded-circle d-flex align-items-center justify-content-center'
                style={{
                  width: '80px',
                  height: '80px',
                  background: 'rgba(11, 14, 20, 0.8)',
                  border: '1px solid rgba(255,255,255,0.1)',
                }}
              >
                <Lock size={40} color='#1da094' />
              </div>
            </div>
            <div
              className='position-absolute animate-spin-custom'
              style={{ inset: 0, animationDuration: '4s' }}
            >
              <div
                style={{
                  position: 'absolute',
                  top: 0,
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  width: '8px',
                  height: '8px',
                  borderRadius: '50%',
                  background: '#1da094',
                  boxShadow: '0 0 12px rgba(29,160,148,0.5)',
                }}
              />
            </div>
          </div>

          <h1 className='fw-bold mb-4 headTitle'>
            <span className='text-foreground'>Lock Your Crypto.</span>
            <br />
            <span className='gradient-text'>Earn Daily Rewards.</span>
          </h1>

          <p
            className='text-muted-foreground subHeadTitle mb-4 mx-auto'
            style={{ maxWidth: '600px', color: '#9AA6B2' }}
          >
            Secure your assets with flexible or fixed lock periods and watch
            your portfolio grow with competitive daily interest rates.
          </p>

          {/* Stats row */}
          <Row className='justify-content-center g-3 mb-5 hide-381'>
            {[
              { value: '14% APY', label: 'On Stables' },
              { value: 'Flexible', label: 'Earn Unlock' },
              { value: 'Daily', label: 'Interest Rates' },
            ].map((stat, i) => (
              <Col
                xs={4}
                md={3}
                key={i}
                className={i === 2 ? 'hide-471' : ''}
              >
                <div className='glass-card p-3 h-100'>
                  <div className='fw-bold text-primary-custom stat-value'>
                    {stat.value}
                  </div>
                  <div className='small text-muted-foreground'>
                    {stat.label}
                  </div>
                </div>
              </Col>
            ))}
          </Row>

          <div className='d-flex flex-column flex-sm-row gap-3 justify-content-center'>
            <button
              className='btn-earn-hero'
              onClick={() => navigate('/comingsoon')}
            >
              Start Earning <ArrowRight size={20} className='ms-2' />
            </button>
            <button
              onClick={() => navigate('/comingsoon')}
              className='btn-earn-hero-outline'
            >
              View All Products
            </button>
          </div>
        </div>
      </Container>
    </section>
  )
}

const LockTypeToggle = ({ type, setType }) => (
  <div className='toggle-container'>
    <button
      onClick={() => setType('flexible')}
      className={`toggle-btn ${type === 'flexible' ? 'active' : ''}`}
    >
      <Unlock size={16} />
      Flexible
    </button>
    <button
      onClick={() => setType('fixed')}
      className={`toggle-btn ${type === 'fixed' ? 'active' : ''}`}
    >
      <Lock size={16} />
      Fixed
    </button>
  </div>
)

const AssetCard = ({ asset, lockType }) => {
  const navigate = useNavigate()
  const [selectedDays, setSelectedDays] = useState(asset.fixed[1].days)
  const selectedFixed =
    asset.fixed.find((f) => f.days === selectedDays) || asset.fixed[1]

  return (
    <div className='asset-card position-relative h-100'>
      {/* Stable coin badge */}
      {asset.isStable && (
        <div
          className='position-absolute top-0 end-0 m-3 px-2 py-1 rounded-pill'
          style={{
            background: 'rgba(16, 185, 129, 0.2)',
            border: '1px solid rgba(16, 185, 129, 0.3)',
          }}
        >
          <span
            className='small fw-bold'
            style={{ color: '#34d399', fontSize: '0.75rem' }}
          >
            Stablecoin
          </span>
        </div>
      )}

      {/* Header */}
      <div className='d-flex align-items-center gap-3 mb-4'>
        <div
          className='rounded-circle d-flex align-items-center justify-content-center shadow-sm'
          style={{ width: '56px', height: '56px', background: asset.color }}
        >
          <span className='text-white fw-bold fs-4'>{asset.icon}</span>
        </div>
        <div>
          <h3 className='h5 fw-bold mb-0 text-white'>{asset.symbol}</h3>
          <p className='small text-muted-foreground mb-0'>{asset.name}</p>
        </div>
      </div>

      {lockType === 'flexible' ? (
        /* Flexible view */
        <div className='d-flex flex-column gap-3'>
          <div
            className='d-flex align-items-center justify-content-between p-3 rounded'
            style={{ background: 'rgba(255,255,255,0.03)' }}
          >
            <div className='d-flex align-items-center gap-2'>
              <Percent size={20} className='text-primary-custom' />
              <span className='text-muted-foreground small'>Est. APY</span>
            </div>
            <span className='fs-4 fw-bold text-primary-custom'>
              {asset.flexible.apy}%
            </span>
          </div>

          <div className='d-flex align-items-center justify-content-between small'>
            <span className='text-muted-foreground d-flex align-items-center gap-1'>
              <Clock size={16} />
              Lock Period
            </span>
            <span className='fw-medium'>No minimum</span>
          </div>

          <div className='d-flex align-items-center justify-content-between small'>
            <span className='text-muted-foreground d-flex align-items-center gap-1'>
              <Zap size={16} />
              Withdrawal
            </span>
            <span className='fw-medium'>Anytime</span>
          </div>

          <button className='btn-earn-hero w-100 mt-2'>Subscribe</button>
        </div>
      ) : (
        /* Fixed view */
        <div className='d-flex flex-column gap-3'>
          {/* Period selector */}
          <div
            className='d-grid gap-2'
            style={{ gridTemplateColumns: 'repeat(3, 1fr)' }}
          >
            {asset.fixed.map((period) => (
              <button
                key={period.days}
                onClick={() => setSelectedDays(period.days)}
                className={`btn btn-sm ${selectedDays === period.days ? 'bg-primary-custom text-white' : 'text-muted-foreground'}`}
                style={{
                  background:
                    selectedDays === period.days
                      ? '#1da094'
                      : 'rgba(255,255,255,0.05)',
                  border: 'none',
                  padding: '0.5rem',
                }}
              >
                {period.days}D
              </button>
            ))}
          </div>

          <div
            className='d-flex align-items-center justify-content-between p-3 rounded'
            style={{ background: 'rgba(255,255,255,0.03)' }}
          >
            <div className='d-flex align-items-center gap-2'>
              <TrendingUp size={20} className='text-primary-custom' />
              <span className='text-muted-foreground small'>Est. APY</span>
            </div>
            <span className='fs-4 fw-bold text-primary-custom'>
              {selectedFixed.apy}%
            </span>
          </div>

          <div className='d-flex align-items-center justify-content-between small'>
            <span className='text-muted-foreground d-flex align-items-center gap-1'>
              <Calendar size={16} />
              Lock Period
            </span>
            <span className='fw-medium'>{selectedDays} Days</span>
          </div>

          <div className='d-flex align-items-center justify-content-between small'>
            <span className='text-muted-foreground d-flex align-items-center gap-1'>
              <Coins size={16} />
              Interest
            </span>
            <span className='fw-medium'>At maturity</span>
          </div>

          <button
            onClick={() => navigate('/comingsoon')}
            className='btn-earn-hero w-100 mt-2'
          >
            Lock {asset.symbol}
          </button>
        </div>
      )}
    </div>
  )
}

const Earn = (props) => {
  const [lockType, setLockType] = useState('fixed')
  return (
    <div className='earn-page'>
      <PageTitleDes title={`Earn Crypto Rewards | Passive Income with Crypto`} description={`Grow your crypto assets by earning rewards. Explore staking and passive income opportunities on Unitic Exchange.`} />
      <NavbarOne setTheme={props.setTheme} />
      <EarnHero />

      {/* How it works */}
      <section className='border-top border-dark border-opacity-25' style={{paddingTop:'50px', paddingBottom:'90px'}}>
        <Container>
          <div className='text-center mb-5'>
            <h2 className='display-6 fw-bold mb-3'>How It Works</h2>
            <p
              className='text-muted-foreground mx-auto'
              style={{ maxWidth: '600px' }}
            >
              Simple steps to start earning passive income on your crypto
            </p>
          </div>

          <Row className='justify-content-center g-4'>
            {[
              {
                step: '01',
                icon: Coins,
                title: 'Choose Asset',
                desc: 'Select from BTC, ETH, SOL, or stablecoins like USDT',
              },
              {
                step: '02',
                icon: Lock,
                title: 'Lock Period',
                desc: 'Pick flexible (withdraw anytime) or fixed term for higher APY',
              },
              {
                step: '03',
                icon: TrendingUp,
                title: 'Earn Daily',
                desc: 'Watch your balance grow with daily compounding interest',
              },
            ].map((item, i) => (
              <Col md={4} key={i}>
                <div className='text-center position-relative pt-4'>
                  <div className='step-number'>{item.step}</div>
                  <div className='position-relative z-10'>
                    <div
                      className='mx-auto mb-4 rounded-circle d-flex align-items-center justify-content-center'
                      style={{
                        width: '64px',
                        height: '64px',
                        background: 'rgba(29, 160, 148, 0.1)',
                        border: '1px solid rgba(29, 160, 148, 0.2)',
                      }}
                    >
                      <item.icon size={32} className='text-primary-custom' />
                    </div>
                    <h3 className='h4 fw-bold mb-2'>{item.title}</h3>
                    <p className='text-muted-foreground small'>{item.desc}</p>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Products section */}
      <section className='position-relative' style={{paddingTop:'80px', paddingBottom:'90px'}}>
        <div
          className='position-absolute top-0 start-0 w-100 h-100'
          style={{
            background:
              'linear-gradient(to bottom, rgba(29, 160, 148, 0.05), transparent)',
            pointerEvents: 'none',
          }}
        />

        <Container className='position-relative z-10'>
          <div className='text-center mb-5'>
            <h2 className='display-6 fw-bold mb-3'>Earn Products</h2>
            <p className='text-muted-foreground mb-4'>
              Choose your preferred lock type and start earning
            </p>

            <LockTypeToggle type={lockType} setType={setLockType} />
          </div>

          <Row className='g-4 mb-5'>
            {cryptoAssets.map((asset) => (
              <Col md={6} lg={3} key={asset.symbol}>
                <AssetCard asset={asset} lockType={lockType} />
              </Col>
            ))}
          </Row>

          {/* Info banner */}
          <div className='glass-card p-4 mx-auto' style={{ maxWidth: '800px' }}>
            <div className='d-flex flex-column flex-sm-row align-items-center gap-4'>
              <div
                className='rounded-circle d-flex align-items-center justify-content-center flex-shrink-0'
                style={{
                  width: '48px',
                  height: '48px',
                  background: 'rgba(29, 160, 148, 0.1)',
                }}
              >
                <Shield size={24} className='text-primary-custom' />
              </div>
              <div className='text-center text-sm-start'>
                <h4 className='h6 fw-bold mb-1'>Your Assets Are Secure</h4>
                <p className='small text-muted-foreground mb-0'>
                  All locked assets are secured with institutional-grade custody
                  and insurance coverage. Interest is calculated daily and
                  claimable after your lock period ends.
                </p>
              </div>
            </div>
          </div>
        </Container>
      </section>

      {/* FAQ section */}
      <section className='pt-5 border-top border-dark border-opacity-25' style={{paddingBottom:'90px'}}>
        <Container>
          <h2 className='display-6 fw-bold text-center mb-5'>
            Frequently Asked Questions
          </h2>

          <Row className='justify-content-center g-4'>
            {[
              {
                q: 'When can I claim my interest?',
                a: 'For fixed lock products, interest is claimable after the lock period ends. For flexible products, you can withdraw anytime along with accrued interest.',
              },
              {
                q: 'What happens if I need my funds early?',
                a: 'Flexible products allow instant withdrawal. Fixed term products require waiting until maturity to avoid early withdrawal penalties.',
              },
              {
                q: 'How is the APY calculated?',
                a: 'APY (Annual Percentage Yield) includes daily compounding. Your daily earnings are automatically added to your locked balance.',
              },
              {
                q: 'Is there a minimum lock amount?',
                a: 'Minimum amounts vary by asset. Generally, you can start with as little as $10 equivalent in any supported cryptocurrency.',
              },
            ].map((faq, i) => (
              <Col md={6} key={i}>
                <div className='glass-card p-4 h-100'>
                  <h4 className='h6 fw-bold mb-2'>{faq.q}</h4>
                  <p className='small text-muted-foreground mb-0'>{faq.a}</p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      <Footer />
    </div>
  )
}

export default Earn
